<!-- Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved. -->
<div class="integration-wrapper" *ngIf="integrationId">
    <form [formGroup]="formGroup">
        <div>
            <mat-form-field class="field-input" appearance="outline">
                <mat-label for="display_name">{{fName}}</mat-label>
                <input matInput name="display_name" type="text" formControlName="display_name" placeholder="{{fName}}">
            </mat-form-field>
        </div>

        <div>
            <mat-form-field class="field-input" appearance="outline">
                <mat-label>{{fThreatNumb}}</mat-label>
                <input matInput id="sensor_type" type="text" formControlName="sensor_type" placeholder="{{fThreatNumbPHolder}}">
            </mat-form-field>
        </div>

        <div>
            <mat-form-field class="field-input" appearance="outline">
                <mat-label>{{fDesc}}</mat-label>
                <input matInput id="description" type="text" formControlName="description" placeholder="{{fDescPHolder}}">
            </mat-form-field>
        </div>

        <pre *ngIf="token"><span class="token">{{ token }}</span></pre>

        <button type="button" (click)="cancel()" mat-raised-button>{{fCancel}}</button>
        <button type="button" color="primary" (click)="save()" [disabled]="!formGroup.valid" mat-raised-button>{{fSave}}</button>
        <button type="button" color="primary" (click)="invalidateSecret()" mat-raised-button *ngIf="token">{{fInvalidate}}</button>

    </form>
</div>
